module.exports = __webpack_public_path__ + "img/receive_05.507188c9.png";